import React, { useState, useCallback } from "react";
import { FormControl, TextField, CircularProgress } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import debounce from "lodash.debounce";

const CustomAutoComplete = ({
  service,
  url,
  mapper,
  onChange,
  inputLabel = "Search",
  inputPlaceholder = "Search by email or name",
  error,
  helperText,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOptions = async (inputValue) => {
    if (inputValue) {
      setLoading(true);
      try {
        const response = await service.get(`${url}?search_term=${inputValue}`);
        const mappedOptions = response?.map(mapper);
        setOptions(mappedOptions);
      } catch (error) {
        console.error("Error fetching options:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setOptions([]);
    }
  };

  const debouncedFetchOptions = useCallback(
    debounce((newInputValue) => {
      fetchOptions(newInputValue);
    }, 500),
    []
  );

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option?.label}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === "input" && newInputValue.length > 2) {
            debouncedFetchOptions(newInputValue);
          }
        }}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            label={inputLabel}
            placeholder={inputPlaceholder}
            variant="outlined"
            error={error}
            helperText={helperText}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  {params.InputProps.startAdornment}
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                </>
              ),
            }}
          />
        )}
        renderOption={(option) => <React.Fragment>{option.label}</React.Fragment>}
      />
    </FormControl>
  );
};

export default CustomAutoComplete;
